<script>
    import R, {LOADER} from "../../lib/requests";
    import {setFocusTo} from "../../lib/lib";
    import Notifier from "../../stores/notifier";
    import Alert from "../../stores/alerts";
    import Modal from '../../components/modal/Modal.svelte';

    export let courier = null;
    export let closeCallback;

    const save = () => {

        const onSuccess = result => {
            Notifier.showMessage("Η courier ενημερώθηκε");
            close(result);
        }

        const onFailure = err => {
            Alert.warning("Ενημέρωση Courier", err.message);
        };

        courier.name = courier.name.trim();
        if (!courier.name) {
            Notifier.showError("Συμπληρώστε το όνομα της courier!");
            setFocusTo("courierName");
            return;
        }

        let action = courier.id == 0 ? 'create' : 'edit';
        R.handle(R.courier[action], courier, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        courier = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    setFocusTo("courierName");
</script>

{#if courier}
    <Modal title="Courier" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Όνομα</label>
                <input type="text" class="form-control" id="courierName" bind:value="{ courier.name }">
            </div>
            <div class="form-group">
                <label>Link</label>
                <input type="text" class="form-control" id="courierLink" bind:value="{ courier.link }"
                placeholder="https://www.courier.gr">
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}
